import { Link } from "react-router-dom";

const footerLinks = {
    Shop: [
        { label: "All Products", to: "/shop" },
        { label: "Categories", to: "/shop" },
        { label: "Cart", to: "/cart" },
    ],
    Account: [
        { label: "My Account", to: "/my-account" },
        { label: "My Orders", to: "/my-account/orders" },
        { label: "Login", to: "/login" },
    ],
    Company: [{ label: "Contact Us", to: "/contact" }],
};

export default function Footer() {
    return (
        <footer className="bg-neutral-900 text-neutral-400 mt-auto">
            <div className="container py-12">
                <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
                    {/* Brand */}
                    <div className="col-span-2 md:col-span-1">
                        <Link to="/" className="flex items-center gap-2">
                            <div className="w-8 h-8 bg-gradient-to-br from-secondary-500 to-secondary-700 rounded-lg flex items-center justify-center">
                                <svg
                                    viewBox="0 0 24 24"
                                    className="w-4 h-4 text-white"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2.2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                >
                                    <path d="M12 2L20 12L12 22L4 12Z" />
                                    <path d="M8 12H16" />
                                    <path d="M12 8V16" />
                                </svg>
                            </div>
                            <span className="text-white font-bold text-xl tracking-tight">
                                <span className="text-white">Fits</span>
                                <span className="text-secondary-400">Aura</span>
                            </span>
                        </Link>
                        <p className="text-sm mt-3 leading-relaxed text-neutral-500 max-w-xs">
                            Curated lifestyle essentials — from timeless apparel and handcrafted accessories to statement pieces that define your everyday elegance.
                        </p>
                    </div>

                    {/* Link Groups */}
                    {Object.entries(footerLinks).map(([group, links]) => (
                        <div key={group}>
                            <h4 className="text-white font-semibold text-sm mb-4">
                                {group}
                            </h4>
                            <ul className="flex flex-col gap-2">
                                {links.map((link) => (
                                    <li key={link.label}>
                                        <Link
                                            to={link.to}
                                            className="text-sm text-neutral-500 hover:text-white transition-colors"
                                        >
                                            {link.label}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>

                {/* Bottom bar */}
                <div className="border-t border-neutral-800 mt-10 pt-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-neutral-600">
                    <p>
                        © {new Date().getFullYear()} FitsAura. All rights
                        reserved.
                    </p>
                    <p>Define your style.™</p>
                </div>
            </div>
        </footer>
    );
}
